import { useAuth } from '@hooks/useAuth'
import { useInhibitKeyPressOverride } from '@hooks/useInhibitKeyPressOverride'
import { useWeekDates } from '@hooks/useWeekDates'
import { useWeekStartsOn } from '@hooks/useWeekStartsOn'
import { WeekSelector as WeekSelectorComponent } from 'components/navigation'
import { FC } from 'react'

const MENU_ID = 'week-selector'

export const WeekSelector: FC = () => {
  const { user } = useAuth()
  const weekStartsOn = useWeekStartsOn()
  const { start, set } = useWeekDates({ weekStartsOn })
  const { registerMenuClosed, registerMenuOpened } =
    useInhibitKeyPressOverride()

  return (
    <WeekSelectorComponent
      onMenuHiddenChange={(hidden) =>
        hidden ? registerMenuClosed(MENU_ID) : registerMenuOpened(MENU_ID)
      }
      onWeekSelect={(startOfWeek) => {
        console.log(
          'WeekSelector feature onWeekSelect:',
          startOfWeek.toISODate(),
        )
        set(startOfWeek)
      }}
      selectedWeek={start}
      weekStartsOn={user?.weekStartsOn ?? 'monday'}
    />
  )
}
